import { Component } from '@angular/core';
import { PageTitleComponent } from '@shared/components/page-title/page-title.component';
import { ChartComponent } from 'ng-apexcharts';
import { RouterLink } from '@angular/router';
import { NgOptionTemplateDirective, NgPlaceholderTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgForOf, NgIf } from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

interface Option {
  value: string;
  label: string;
}

@Component({
  selector: 'app-building-dashboard',
  standalone: true,
  imports: [
    PageTitleComponent,
    ChartComponent,
    RouterLink,
    NgSelectComponent,
    FormsModule,
    NgOptionTemplateDirective,
    NgPlaceholderTemplateDirective,
    NgIf,
    NgForOf,
    TranslatePipe
  ],
  templateUrl: './building-dashboard.component.html',
  styleUrl: './building-dashboard.component.scss'
})
export class BuildingDashboardComponent {

  public donutChartOptions: any;
  public stackedColumnChartOptions: any;
  public structureWidget: any;


  ngOnInit(): void {
    this.initializeDonutChartOptions('["--in-primary", "--in-light"]');
    this.initializeStackedColumnChart('["--in-primary", "--in-light"]');
    this.initializeStructureWidget('["--in-primary", "--in-light"]');
  }

  selectedOption1: string;
  selectedOption2: string;
  selectedOption3: string;
  //mock data for searching
  options: Option[] = [
    {value: 'option1', label: 'Lindestrabe 9-14, 10969 Berlin'},
    {value: 'option2', label: 'Dresdener Str.126, 10999 Berlin'},
    {value: 'option3', label: 'Fromet-und-Moses-Mendelssohn-Platz, 10969 Berlin'},

  ];
  buildings: Option[] = [
    {value: 'option11', label: 'Lindestrabe 9-14, 10969 Berlin'},
    {value: 'option22', label: 'Dresdener Str.126, 10999 Berlin'},
    {value: 'option33', label: 'Fromet-und-Moses-Mendelssohn-Platz, 10969 Berlin'},
  ];
  apartment: Option[] = [
    {value: 'option1111', label: '12D-1E'},
    {value: 'option2222', label: '10R-2W'},
    {value: 'option3333', label: '10D-3E'},
  ];


  private initializeStructureWidget(color: string): void {
    const colors = ['#801130', '#b69d16', '#5785fc'];


    this.structureWidget = {
      chart: {
        height: 300,
        type: 'donut',
      },
      series: [40, 18, 13],
      labels: ["Invoiced", "Collected", "Outstanding"],
      colors: colors,
      plotOptions: {
        pie: {
          startAngle: 25,
          donut: {
            size: '78%',
          }
        }
      },

      legend: {
        show: false,
      },

      dataLabels: {
        style: {
          fontSize: '11px',
          fontFamily: 'DM Sans,sans-serif',
          colors: undefined
        },

        background: {
          enabled: true,
          foreColor: '#fff',
          padding: 4,
          borderRadius: 2,
          borderWidth: 1,
          borderColor: '#fff',
          opacity: 1,
        },
      },
      responsive: [{
        breakpoint: 600,
        options: {
          chart: {
            height: 240
          },
          legend: {
            show: false
          },
        }
      }]
    }
  }

  private initializeStackedColumnChart(color: string): void {
    const colors = ['#5785fc', '#00000000'];

    if (colors) {
      this.stackedColumnChartOptions = {
        chart: {
          height: 300,
          type: 'bar',
          stacked: false,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
            borderRadiusApplication: 'end',
            horizontal: false,
            columnWidth: '40%',
            borderRadius: 5,
          }
        },
        plotOptions2: {
          bar: {
            borderRadiusApplication: 'end',
            horizontal: false,
            columnWidth: '70%',
            borderRadius: 2,
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
        },
        dataLabels2: {
          enabled: false,
          offsetY: -20,
        },
        series: [
          {
            name: 'readings',
            data: [38, 48, 41, 52, 22, 43, 36, 48, 24, 28, 36, 44]
          }
        ],
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true,
            }
          }
        },
        colors: colors,
        legend: {
          show: true
        },
        fill: {
          opacity: 1
        }
      };
    }
  }

  private initializeDonutChartOptions(color: string): void {
    const colors = ['#801130', '#00000000'];
    this.donutChartOptions = {
      series: [75, 25],
      chart: {
        type: 'donut',
        height: 80,
        width: 80
      },
      colors: colors,
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      plotOptions: {
        pie: {
          donut: {
            size: '80%',
          },
        },
      }
    };
  }
}
